<app-header></app-header>
<div class="jumbotron jumbotron-success d-flex align-items-center min-vh-100">
    <div class="container text-center">
     <h1 class="styleheader display-4"><strong>Information Technology Services Solutions. <br>Tailored to your IT Needs</strong></h1> 
    </div>
 </div>       
<app-homecontent></app-homecontent>
<app-getintouch  [pageindex]=pagenumber></app-getintouch>
<app-footer></app-footer>
